import PosActions from '../../../../actions/PosActions';
import PosStore from '../../../../stores/PosStore';

class AvailableFeeDonations extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            availableFeesDonations : PosStore.getState().availableFeesDonations
        };

        this.componentWillMount = this.componentWillMount.bind(this);
        this.onPosStoreChange = this.onPosStoreChange.bind(this);
        this.selectFeeDonation = this.selectFeeDonation.bind(this);
    }

    componentWillMount() {
        PosActions.loadAvailableFeesDonations();
        PosStore.addChangeListener(this.onPosStoreChange);
    }

    componentWillUnmount() {
        PosStore.removeChangeListener(this.onPosStoreChange);
    }

    onPosStoreChange() {
        this.setState({
            availableFeesDonations : PosStore.getState().availableFeesDonations
        });
    }

    selectFeeDonation(feeDonation) {
        this.props.selectFeeDonation(feeDonation);
    }

    render() {
        var self = this;
        var rowStyle    = '#ffffff';
        var activeFeesDonations = this.state.availableFeesDonations
        var selectedFeeDonation    = this.props.selectedFeeDonation;

        return (
            <div className='available-discounts'>
                <div className='available-discounts__header'>
                    {'AVAILABLE FEES & DONATIONS'}
                </div>

                <div className='available-discounts__description'>
                    <div className='available-discounts__row--name'>
                        {'Applicable Fees & Donations'}
                    </div>
                </div>

                <div className='available-discounts__container'>
                    { activeFeesDonations.filter(f => !f.IsAutomatic).map((feeDonation) => {
                        rowStyle = rowStyle === '#ffffff' ? '#ebebeb' : '#ffffff';

                        return(
                            <div
                                className='pt-2 pb-2'
                                style={{'backgroundColor' : (selectedFeeDonation && selectedFeeDonation.FeeDonationId === feeDonation.FeeDonationId ? '#C0F0B9' : rowStyle) }}
                                onClick={self.selectFeeDonation.bind(self, feeDonation)}
                                key={feeDonation.FeeDonationId}>
                                
                                <div className='available-discounts__row'>
                                    {feeDonation.Name} <br/>
                                </div>

                                <div className='row'>
                                    <div className='col-8'>
                                        {feeDonation.CalculationMethod}
                                    </div>

                                    <div className='col-4'>
                                        {' Amount : ' + feeDonation.CalculationValue}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        );
    }
}

export default AvailableFeeDonations;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/sidebar/feesDonations/AvailableFeesDonations.react.jsx